import { z } from 'zod';
const environmentSchema = z.enum(['local', 'staging', 'production']);
export const sentryConfigSchema = z.object({
    dsn: z.string().url('Sentry DSN must be a valid URL'),
    environment: environmentSchema,
    debug: z.boolean().default(false),
    tracesSampleRate: z.number().min(0).max(1).default(0.1),
    profilesSampleRate: z.number().min(0).max(1).default(0.1),
});
export const monitoringConfigSchema = z.object({
    sentry: sentryConfigSchema.optional(),
});
